import { generateXML } from './XMLGeneration';

const XMLViewer = ({data}) => {
    const xml = generateXML(data);
    return (
        <div>
        <h1>XML Viewer</h1>
        <pre>{xml}</pre>
        </div>
    );
}

export default XMLViewer;